var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "section",
        {
          staticClass: "login-area black-bg p-0 py-4 py-sm-2",
        },
        [
          _c(
            "div",
            {
              staticClass: "row content",
            },
            [
              _c(
                "div",
                {
                  staticClass: "login-section col-lg-6 col-md-12 px-0 py-3",
                },
                [
                  _c(
                    "h2",
                    {
                      staticClass: "sr-only",
                    },
                    [_vm._v(_vm._s(_vm.fcoM("common.logIn", "Log In")))]
                  ),
                  _vm._v(" "),
                  _c("OpcValidationObserver", {
                    ref: "validator",
                    attrs: {
                      tag: "div",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (_ref) {
                          var validate = _ref.validate
                          return [
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(_vm.handleSubmit)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "login-form",
                                  },
                                  [
                                    _vm.lockWarning
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "alert alert-danger p-2 d-flex",
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c("Icon", {
                                                    staticClass:
                                                      "medium red lock",
                                                    attrs: {
                                                      name: "lock",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "flex-fill",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.fcoM(
                                                          "rs.home.lockWarning",
                                                          "Your access will be locked on the next failed username or password attempt."
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                  _c(
                                                    "FcoLink",
                                                    {
                                                      staticClass:
                                                        "gtm-login-forgot-password",
                                                      attrs: {
                                                        to: "/forgot-password",
                                                        href: _vm.fcoUrl(
                                                          "/forgotpassword.html"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.fcoM(
                                                            "rs.home.forgotUserPass",
                                                            "Forgot Username or Password?"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.loginErrorMessage
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "alert alert-danger p-2 d-flex",
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _c("Icon", {
                                                  staticClass:
                                                    "medium red exclamation",
                                                  attrs: {
                                                    name: "exclamation",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flex-fill",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.loginErrorMessage
                                                    ) +
                                                    "\n                                        "
                                                ),
                                                _vm.showForgotPassword
                                                  ? _c(
                                                      "FcoLink",
                                                      {
                                                        staticClass:
                                                          "gtm-login-forgot-password",
                                                        attrs: {
                                                          to: "/forgot-password",
                                                          href: _vm.fcoUrl(
                                                            "/forgotpassword.html"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.fcoM(
                                                              "rs.home.forgotUserPass",
                                                              "Forgot Username or Password?"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-name select-box mb-2",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "sr-only",
                                            attrs: {
                                              for: "userName",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.fcoM(
                                                  "common.userName",
                                                  "Username"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: {
                                              required: true,
                                              basicChars: true,
                                              regex:
                                                /^[A-Za-z0-9]{3,}(?:@oreillyauto\.(com|mx))?$/,
                                              min: 3,
                                              max: 50,
                                            },
                                            name: _vm.fcoM(
                                              "common.userName",
                                              "Username"
                                            ),
                                            tag: "div",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (_ref2) {
                                                  var errors = _ref2.errors,
                                                    classes = _ref2.classes
                                                  return [
                                                    _c("Icon", {
                                                      staticClass:
                                                        "input-icon medium med-gray user",
                                                      attrs: {
                                                        name: "user",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.loginForm
                                                              .loginName,
                                                          expression:
                                                            "loginForm.loginName",
                                                        },
                                                      ],
                                                      class: [
                                                        classes,
                                                        "qaa-js-login-user",
                                                        "highlight-on-focus",
                                                      ],
                                                      attrs: {
                                                        type: "text",
                                                        id: "loginName",
                                                        placeholder: _vm.fcoM(
                                                          "common.userName",
                                                          "Username"
                                                        ),
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.loginForm
                                                            .loginName,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.loginForm,
                                                            "loginName",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "password select-box mb-2",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "sr-only",
                                            attrs: {
                                              for: "password",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.fcoM(
                                                  "common.password",
                                                  "Password"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: {
                                              required: true,
                                              min: 3,
                                            },
                                            name: _vm.fcoM(
                                              "common.password",
                                              "Password"
                                            ),
                                            tag: "div",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (_ref3) {
                                                  var errors = _ref3.errors,
                                                    classes = _ref3.classes
                                                  return [
                                                    _c("Icon", {
                                                      staticClass:
                                                        "input-icon medium med-gray lock",
                                                      attrs: {
                                                        name: "lock",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.loginForm
                                                              .password,
                                                          expression:
                                                            "loginForm.password",
                                                        },
                                                      ],
                                                      class: [
                                                        classes,
                                                        "qaa-js-login-password",
                                                        "highlight-on-focus",
                                                      ],
                                                      attrs: {
                                                        type: "password",
                                                        id: "password",
                                                        placeholder: _vm.fcoM(
                                                          "common.password",
                                                          "Password"
                                                        ),
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.loginForm
                                                            .password,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.loginForm,
                                                            "password",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "error",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "remember-me d-block d-sm-flex",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-control custom-checkbox",
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.loginForm.rememberMe,
                                                  expression:
                                                    "loginForm.rememberMe",
                                                },
                                              ],
                                              staticClass:
                                                "ignore custom-control-input",
                                              attrs: {
                                                id: "rememberMe",
                                                type: "checkbox",
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.loginForm.rememberMe
                                                )
                                                  ? _vm._i(
                                                      _vm.loginForm.rememberMe,
                                                      null
                                                    ) > -1
                                                  : _vm.loginForm.rememberMe,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.loginForm.rememberMe,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.loginForm,
                                                          "rememberMe",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.loginForm,
                                                          "rememberMe",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.loginForm,
                                                      "rememberMe",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "d-inline-block white custom-control-label",
                                                attrs: {
                                                  for: "rememberMe",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.fcoM(
                                                        "rs.home.staySignedIn",
                                                        "Stay Signed In"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "FcoLink",
                                          {
                                            staticClass:
                                              "ml-auto gtm-login-forgot-password forgotUsernamePasswordLink",
                                            attrs: {
                                              to: "/forgot-password",
                                              href: _vm.fcoUrl(
                                                "/forgotpassword.html"
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.fcoM(
                                                    "rs.home.forgotUserPass",
                                                    "Forgot Username or Password?"
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "submit d-block pt-3",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button py-2 px-3 mr-0 mr-sm-2 mr-lg-1 gtm-login qaa-gtm-login",
                                            attrs: {
                                              type: "submit",
                                              disabled: _vm.isLoading,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.fcoM(
                                                    "common.logIn",
                                                    "Log In"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                            !_vm.isLoading
                                              ? _c("Icon", {
                                                  staticClass:
                                                    "medium chevron-right",
                                                  attrs: {
                                                    id: "gtm-svg-login",
                                                    name: "chevron-right",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isLoading
                                              ? _c("Icon", {
                                                  staticClass: "medium refresh",
                                                  attrs: {
                                                    name: "refresh",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("ChatButton", {
                                          staticClass: "chat-help",
                                          attrs: {
                                            buttonClass: "text-color-inherit",
                                            label: _vm.fcoM(
                                              "common.chatForHelp",
                                              "Chat for Help"
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-6 col-md-12 login-section",
                },
                [
                  _c(
                    "h2",
                    {
                      staticClass: "sr-only",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.fcoM("common.requestAccess", "Request Access")
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "request-access mt-lg-3 p-4 p-md-0 d-md-flex d-lg-block",
                    },
                    [
                      _c(
                        "FcoLink",
                        {
                          staticClass:
                            "button py-2 px-3 mr-0 mr-sm-2 mr-sm-0 text-center qaa-request-access d-block d-lg-inline-block",
                          attrs: {
                            to: "/account-request",
                            href: _vm.fcoUrl("/accountrequest/request.html"),
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.fcoM(
                                  "common.requestAccess",
                                  "Request Access"
                                )
                              ) +
                              "\n                        "
                          ),
                          _c("Icon", {
                            staticClass: "medium chevron-right",
                            attrs: {
                              name: "chevron-right",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "mb-0 ml-0 ml-sm-2 ml-lg-0",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.fcoM(
                              "rs.home.requestAssist",
                              "If you have an O'Reilly Auto Parts account number or wish to sign up for O'Reilly Pro we can assist you."
                            )
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.$fcoMq.isSmDown
        ? _c(
            "section",
            {
              staticClass: "marketing-area white-bg d-none d-sm-block pb-4",
            },
            [
              _c(
                "div",
                {
                  staticClass: "content mb-0 d-none d-md-block",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-9",
                        },
                        [
                          _c(
                            "h2",
                            {
                              staticClass: "sr-only",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.fcoM(
                                    "rs.home.carouselHeader",
                                    "Featured Spotlight"
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("BannerZone", {
                            attrs: {
                              name: "login-slider",
                              carousel: "",
                              location: _vm.Page.LOGIN,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-3",
                        },
                        [
                          _c("BannerZone", {
                            staticClass: "gtm-login-credit mb-3",
                            attrs: {
                              name: "login-side-banner-top",
                              "aspect-ratio": "94 / 65",
                              location: _vm.Page.LOGIN,
                            },
                          }),
                          _vm._v(" "),
                          _c("BannerZone", {
                            staticClass: "gtm-login-direct-capital",
                            attrs: {
                              name: "login-side-banner-bottom",
                              "aspect-ratio": "16 / 5",
                              location: _vm.Page.LOGIN,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("MarketingBoxes"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }